import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/')({
  beforeLoad: ({
    params,
    search
  }) => {
    throw redirect({
      to: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page',
      params: {
        cycleId: params.cycleId,
        fortySurveyType: params.fortySurveyType,
        surveyId: params.surveyId,
        page: '1'
      },
      search: search
    });
  }
});